export enum PreferenceGroup {
  HISTORY = "history",
  LIST_VIEW = "list_view",
}
export enum HistoryPreferenceKey {
  SEARCH_HISTORY = "search_history",
}
export enum ListViewPreferenceKey {
  GLOBAL = "global",
  ACCOUNT = "account",
  COUNTRY = "country",
  LOCATION = "location",
  ROOM = "room",
  DEVICE = "device",
  DEVICE_CATALOG = "device_catalog",
  TICKET = "ticket",
  TICKET_TAB = "ticket_tab",
  MEETING = "meeting",
  USER = "user",
  TRIGGER = "trigger",
  WORKFLOW = "workflow",
  AUDIT_TRAIL = "audit_trail",
  ROOM_SWEEP = "room_sweep",
  ROLES_CAPABILITIES = "roles_capabilities",
  MESSAGING = "messaging",
  ARCHIVE_DEVICE = "archive_device",
  WORKFLOW_RESULT_LOG = "workflow_result_log",
  BUILD_YOUR_OWN_REPORT = "build_your_own_report",
  DEVICE_ADAPTER = "device_adapter",
  ROOM_CUSTOMIZATION_FIELD = "room_customization_field",
  HELP_AND_RESOURCES = "help_and_resources",
}

export type ListViewSpecificPreferenceKey = Exclude<
  ListViewPreferenceKey,
  ListViewPreferenceKey.GLOBAL
>;
export type PreferenceKey = HistoryPreferenceKey | ListViewPreferenceKey;
export const PreferenceKeyImpl: { [k in PreferenceKey]: k } = {
  [HistoryPreferenceKey.SEARCH_HISTORY]: HistoryPreferenceKey.SEARCH_HISTORY,
  [ListViewPreferenceKey.GLOBAL]: ListViewPreferenceKey.GLOBAL,
  [ListViewPreferenceKey.ACCOUNT]: ListViewPreferenceKey.ACCOUNT,
  [ListViewPreferenceKey.COUNTRY]: ListViewPreferenceKey.COUNTRY,
  [ListViewPreferenceKey.LOCATION]: ListViewPreferenceKey.LOCATION,
  [ListViewPreferenceKey.ROOM]: ListViewPreferenceKey.ROOM,
  [ListViewPreferenceKey.DEVICE]: ListViewPreferenceKey.DEVICE,
  [ListViewPreferenceKey.DEVICE_CATALOG]: ListViewPreferenceKey.DEVICE_CATALOG,
  [ListViewPreferenceKey.TICKET]: ListViewPreferenceKey.TICKET,
  [ListViewPreferenceKey.TICKET_TAB]: ListViewPreferenceKey.TICKET_TAB,
  [ListViewPreferenceKey.MEETING]: ListViewPreferenceKey.MEETING,
  [ListViewPreferenceKey.USER]: ListViewPreferenceKey.USER,
  [ListViewPreferenceKey.TRIGGER]: ListViewPreferenceKey.TRIGGER,
  [ListViewPreferenceKey.WORKFLOW]: ListViewPreferenceKey.WORKFLOW,
  [ListViewPreferenceKey.AUDIT_TRAIL]: ListViewPreferenceKey.AUDIT_TRAIL,
  [ListViewPreferenceKey.ROOM_SWEEP]: ListViewPreferenceKey.ROOM_SWEEP,
  [ListViewPreferenceKey.ROLES_CAPABILITIES]:
    ListViewPreferenceKey.ROLES_CAPABILITIES,
  [ListViewPreferenceKey.MESSAGING]: ListViewPreferenceKey.MESSAGING,
  [ListViewPreferenceKey.ARCHIVE_DEVICE]: ListViewPreferenceKey.ARCHIVE_DEVICE,
  [ListViewPreferenceKey.WORKFLOW_RESULT_LOG]:
    ListViewPreferenceKey.WORKFLOW_RESULT_LOG,
  [ListViewPreferenceKey.BUILD_YOUR_OWN_REPORT]:
    ListViewPreferenceKey.BUILD_YOUR_OWN_REPORT,
  [ListViewPreferenceKey.DEVICE_ADAPTER]: ListViewPreferenceKey.DEVICE_ADAPTER,
  [ListViewPreferenceKey.ROOM_CUSTOMIZATION_FIELD]:
    ListViewPreferenceKey.ROOM_CUSTOMIZATION_FIELD,
  [ListViewPreferenceKey.HELP_AND_RESOURCES]:
    ListViewPreferenceKey.HELP_AND_RESOURCES,
};
export type UserPreferences<
  T,
  N extends PreferenceGroup,
  K extends PreferenceKey
> = {
  value: T;
  preferenceGroup: N;
  key: K;
};

export type SavedSearchesValue = {
  savedSearches: string[];
};
export type Preferences_SavedSearches = UserPreferences<
  SavedSearchesValue,
  PreferenceGroup.HISTORY,
  HistoryPreferenceKey.SEARCH_HISTORY
>;

export type ListViewGlobalValues = {
  pageSize: number;
  bulkImportPageSize: number;
};

export type ColumnWidthDefinition = {};
export type ListViewSpecificValues = {
  columnOrder: string[];
  columnWidths: { [k in string]: number };
};
